import { createFileRoute } from "@tanstack/react-router";
import AdminOrganizationTeamPage from "@/pages/admin/organizations/detail/team";

export const Route = createFileRoute("/app/admin/organizations/$organizationId/team")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationId } = Route.useParams();

  return <AdminOrganizationTeamPage organizationId={Number(organizationId)} />;
}
